import { TPAComponentProps } from '../../types';
import { CoreButtonNextProps } from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext';
import { SocialBarThemes } from './consts';

export type SocialBarThemesType = keyof typeof SocialBarThemes;

export interface SocialBarProps extends TPAComponentProps {
  theme?: SocialBarThemesType;
  children?: React.ReactNode | React.ReactNode[];
  Icon?: React.ReactNode;
}

export interface SocialBarInjectedProps {
  socialBarTheme?: SocialBarThemesType;
}

export interface SocialBarIconProps
  extends CoreButtonNextProps,
    TPAComponentProps,
    SocialBarInjectedProps {
  tooltip?: string;
  icon: React.ReactNode;
  hasLiveRegion?: boolean;
}
